(() => {
  'use strict';
  if (window.__zaCompletionInit) { window.__zaCompletionInit(); return; }
  const instances = new Map();
  const storageKey = 'za:offer-completion:v1';
  const readPending = () => { try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; } };
  const clearPending = () => { try { sessionStorage.removeItem(storageKey); } catch {} };
  const sameProduct = (item, product) => Number(item.quantity) > 0 && (String(item.product_id) === String(product.id) || item.handle === product.handle);
  const path = (url) => { try { return new URL(url, location.origin).pathname.replace(/\/$/, ''); } catch { return ''; } };
  const readCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
    return cart;
  };
  function initialize(scope = document) {
    scope.querySelectorAll('[data-za-offer-completion]').forEach((root) => {
      if (instances.has(root) || root.dataset.enabled !== 'true') return;
      const config = JSON.parse(root.querySelector('[data-za-completion-config]').textContent);
      const offers = config.offers.filter(offer => offer.products.every(product => product.id && product.handle && product.url));
      const dialog = root.querySelector('dialog'), form = root.querySelector('form'), pay = form.querySelector('button');
      const error = root.querySelector('[data-za-complete-error]');
      const controller = new AbortController(), options = { signal: controller.signal };
      let activeOffer = null, previousFocus = null, checkoutApproved = false, version = 0;
      const complete = (cart, offer) => offer.products.every(product => cart.items.some(item => sameProduct(item, product)));
      const pendingOffer = () => {
        const pending = readPending();
        if (!pending || Date.now() - pending.created > 3600000 || pending.created > Date.now()) { clearPending(); return null; }
        const offer = offers.find(offer => offer.id === pending.id && offer.products.some(product => product.handle === pending.target));
        return offer ? { offer, pending } : null;
      };
      const closeDrawer = () => { const drawer = document.querySelector('cart-drawer.active'); if (drawer?.close) drawer.close(); };
      const showError = text => { error.textContent = text; error.hidden = false; };
      const show = (cart, offer) => {
        activeOffer = offer;
        previousFocus = document.querySelector('product-form button[name="add"]') || document.activeElement;
        root.querySelector('[data-za-complete-label]').textContent = offer.label;
        const list = root.querySelector('[data-za-complete-products]');
        list.replaceChildren();
        offer.products.forEach(product => {
          const item = cart.items.find(item => sameProduct(item, product));
          const li = document.createElement('li'), image = document.createElement('img'), title = document.createElement('p'), variant = document.createElement('small');
          const source = typeof item.image === 'string' ? item.image : item.featured_image?.url || item.image?.src;
          if (source) { image.src = source; image.alt = ''; image.width = 240; image.height = 240; li.append(image); }
          title.textContent = item.product_title || item.title;
          variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title || '';
          li.append(title, variant); list.append(li);
        });
        error.hidden = true;
        closeDrawer();
        document.querySelectorAll('quick-add-modal[open]').forEach(modal => modal.hide?.());
        document.body.classList.add('za-complete-open');
        dialog.showModal();
        pay.focus({ preventScroll: true });
      };
      document.addEventListener('click', event => {
        const cta = event.target.closest('[data-zionic-cta]');
        if (!cta || cta.closest('[data-zionic-promo-hub]')?.getAttribute('aria-hidden') !== 'false') return;
        const offer = offers.find(offer => offer.products.some(product => path(product.url) === path(cta.href)));
        if (!offer) return;
        const target = offer.products.find(product => path(product.url) === path(cta.href));
        try { sessionStorage.setItem(storageKey, JSON.stringify({ id: offer.id, target: target.handle, created: Date.now() })); } catch {}
      }, { ...options, capture: true });
      const onCartUpdate = async data => {
        if (data?.source !== 'product-form' || dialog.open) return;
        const tracked = pendingOffer();
        if (!tracked) return;
        const currentVersion = ++version;
        try {
          const cart = await readCart();
          if (controller.signal.aborted || currentVersion !== version) return;
          const latest = pendingOffer();
          if (!latest || latest.pending.created !== tracked.pending.created) return;
          const target = tracked.offer.products.find(product => product.handle === tracked.pending.target);
          if (!cart.items.some(item => sameProduct(item, target) && String(item.variant_id || item.id) === String(data.productVariantId))) return;
          if (!complete(cart, tracked.offer)) return;
          clearPending();
          show(cart, tracked.offer);
        } catch {}
      };
      const unsubscribe = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' ? subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate) : null;
      root.querySelectorAll('[data-za-complete-close]').forEach(button => button.addEventListener('click', () => dialog.close(), options));
      dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('button:not(:disabled)')];
        const index = controls.indexOf(document.activeElement);
        event.preventDefault();
        controls[(index + (event.shiftKey ? -1 : 1) + controls.length) % controls.length]?.focus();
      }, options);
      dialog.addEventListener('close', () => {
        document.body.classList.remove('za-complete-open');
        activeOffer = null;
        if (!controller.signal.aborted && previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }, options);
      form.addEventListener('submit', async event => {
        if (checkoutApproved) return;
        event.preventDefault();
        if (pay.disabled || !activeOffer) return;
        pay.disabled = true; pay.setAttribute('aria-busy', 'true'); error.hidden = true;
        try {
          const cart = await readCart();
          if (controller.signal.aborted || !dialog.open) return;
          if (!complete(cart, activeOffer)) { showError(config.incomplete); return; }
          checkoutApproved = true;
          pay.disabled = false;
          form.requestSubmit(pay);
        } catch { showError(config.error); }
        finally { pay.disabled = false; pay.removeAttribute('aria-busy'); }
      }, options);
      const drawer = document.querySelector('cart-drawer');
      const observer = new MutationObserver(() => { if (dialog.open) closeDrawer(); });
      if (drawer) observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      instances.set(root, () => { controller.abort(); unsubscribe?.(); observer.disconnect(); version++; if (dialog.open) dialog.close(); document.body.classList.remove('za-complete-open'); instances.delete(root); });
    });
  }
  window.__zaCompletionInit = initialize;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { instances.forEach((dispose, root) => { if (event.target.contains(root)) dispose(); }); });
})();
